
// Init footer elements after document is ready
export function initFooter() {
  
  console.log('initFooter()');
}